






























































































































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '@/CommonFeature/components/ApiAccessBase.vue';
import router from '@/router';
// 共通モジュール
import { supervisingModule } from '@/store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { traderInfoModule } from '../store/modules/TraderInfo';
import { CustomScreenName } from '../fixed/CustomScreenName';
import { UketsukeScreenName } from '../../fixed/UketsukeScreenName';
import { Constants } from '@/CommonUtils/fixed/Constants';
import { CustomConstants } from '../fixed/CustomConstants';
import { ScreenMode } from '@/CommonUtils/fixed/ScreenMode';
import { applicationFormModule } from '../../store/modules/ApplicationForm';
// 拡張コンポーネント
// import TraderInfoGroup from '@/Uketsuke/custom/components/TraderInfoGroup.vue';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);
// Vue.component('traderInfoGroup', TraderInfoGroup);

@Component
export default class TraderInfo extends ApiAccessBase {
  private mode: boolean = true; //画面モード(非 参照モード)
  private masterEditionsTeijiFlg: boolean = false;
  // 拡張パネルの設定（検索条件）
  private exPanel: number[] = [];
  private exPanelBk: number[] = [];

  private variableColNames: string[] = [];
  private GROUP_LAYOUT_ARRAY: string = Constants.GROUP_LAYOUT_ARRAY;
  private GROUP_LAYOUT_LIST: string = Constants.GROUP_LAYOUT_LIST;
  private HYOJI_DATA: string = '';
  private TEIJI_FLG: string = 'init';
  private EDIT_FLG: string = 'init';

  private created() {
    // モジュール内のキーを使ってデータ取得
    // getInit呼び出し
    this.apiAccess(
      CustomConstants.TRADER_INFO_WORKTYPES_INIT_PATH + '/' +
      applicationFormModule.GET_TRADER_ID + '/' +
      supervisingModule.GET_MODE + '/' + //画面モード
      this.TEIJI_FLG + '/' + //定期フラグ
      this.EDIT_FLG, //定期/中間1/中間2情報切替時の登録可否フラグ
      Constants.API_METHOD_GET,
      false,
      false,
    ).then((result) => {
      if ((result) === Constants.API_RESULT_SUCCES) {
        if (this.formData.teijiFlg === this.formData.masterEditionsTeijiFlg) {
          this.masterEditionsTeijiFlg = true; //登録ボタン活性
        } else {
          this.masterEditionsTeijiFlg = false; //登録ボタン非活性
        }
        if (supervisingModule.GET_MODE === ScreenMode.READ) {
          this.mode = false; //画面モード設定(参照モード)
        }
        this.setAllVariablecolsState();
        let panelIndex = 0;
        for (const variablecol of Object.keys(this.variablecols)) {
          // パネル設定全オープン
          this.exPanel.push(panelIndex);
          panelIndex++;
          this.variableColNames.push(variablecol);
        }
        this.exPanelBk = this.exPanel.concat();
        this.TEIJI_FLG = this.formData.teijiFlg; //定期フラグ
        this.hyojiData();
      }
    });
  }

  /**
   * 定期ボタン
   */
  private dataChange0() {
    this.dataChange(CustomConstants.PERIODIC);
  }

  /**
   * 中間1ボタン
   */
  private dataChange1() {
    this.dataChange(CustomConstants.INTERMEDIATE);
  }

  /**
   * 中間2ボタン
   */
  private dataChange2() {
    this.dataChange(CustomConstants.INTERMEDIATE2);
  }

  private dataChange(teijiFlg: string) {
    this.TEIJI_FLG = teijiFlg;
    if (this.TEIJI_FLG === this.formData.masterEditionsTeijiFlg
      && supervisingModule.GET_MODE !== ScreenMode.READ) { //表示しようとしているデータが申請期間中(masterEditions.yobi01) かつ 参照モードでないデータの場合
      this.EDIT_FLG = ScreenMode.UPDATE; //データを登録モードで表示
      supervisingModule.setMode(ScreenMode.UPDATE); //参照モード解除
    } else {
      this.EDIT_FLG = ScreenMode.READ; //データを参照モードで表示
    }
    // 先頭へジャンプ
    this.hrefElement('TraderInfoWorkTypes', -100);
    this.apiAccess(
      CustomConstants.TRADER_INFO_WORKTYPES_INIT_PATH + '/' +
      applicationFormModule.GET_TRADER_ID + '/' +
      supervisingModule.GET_MODE + '/' + //画面モード
      this.TEIJI_FLG + '/' + //定期フラグ
      this.EDIT_FLG, //定期/中間1/中間2情報切替時の登録可否フラグ
      Constants.API_METHOD_GET,
      false,
      false,
    ).then((result) => {
      if ((result) === Constants.API_RESULT_SUCCES) {
        if (this.TEIJI_FLG === this.formData.masterEditionsTeijiFlg) {
          this.masterEditionsTeijiFlg = true; //登録ボタン活性化
        } else {
          this.masterEditionsTeijiFlg = false; //登録ボタン非活性
        }
        if (supervisingModule.GET_MODE === ScreenMode.READ) {
          this.mode = false; //画面モード設定(参照モード)
        } else {
          this.mode = true; //画面モード設定(登録モード)
        }
        this.hyojiData();
      }
    });
  }

  private hyojiData() {
    if (this.TEIJI_FLG === CustomConstants.PERIODIC) {
      this.HYOJI_DATA = '表示中データ：定期';
    } else if (this.TEIJI_FLG === CustomConstants.INTERMEDIATE) {
      this.HYOJI_DATA = '表示中データ：中間1';
    } else if (this.TEIJI_FLG === CustomConstants.INTERMEDIATE2) {
      this.HYOJI_DATA = '表示中データ：中間2';
    }
  }

  /**
   * 登録
   */
  private regist() {
    // form成形
    // this.moldingSendForm(this.$refs.form);
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // 先頭へジャンプ
    this.hrefElement('TraderInfoWorkTypes', -100);
    this.apiAccess(
      CustomConstants.TRADER_INFO_WORKTYPES_UPDATE_PATH + '/' + applicationFormModule.GET_TRADER_ID,
      Constants.API_METHOD_POST,
      true,
      null)
    .then((result) => {
    });
  }

  private exPanelAllClose() {
    this.exPanel = [];
  }
  private exPanelAllOpen() {
    this.exPanel = this.exPanelBk.concat();
  }
  private returnPrevious() {
    router.push({ name: UketsukeScreenName.APPLICATION_FORM });
  }
}
